import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["buttonTitle", "jobPositionId", "redirectUrl", "ambassadorRefCode", "title", "variant", "onClick"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import { useMemo } from 'react';
import { RWebShare } from 'react-web-share';
import { useTranslation } from 'next-i18next';
import { useGlobalsService } from '@restworld/data-services';
import { BASE_URL } from '@restworld/utils-common';
import { Button } from '../../design-system';
import { jsx as _jsx } from "react/jsx-runtime";
var text = 'Hey, ti stavo pensando leggendo questa offerta di lavoro. Apri il link per vedere tutti i dettagli e candidarti!';

var commonString = function commonString(ambassadorRefCode) {
  return "utm_source=referral&utm_medium=ambassador&utm_campaign=worker_acquisition&ref_code=".concat(ambassadorRefCode);
};

export var JobShareModal = function JobShareModal(_ref) {
  var _ref$buttonTitle = _ref.buttonTitle,
      buttonTitle = _ref$buttonTitle === void 0 ? '' : _ref$buttonTitle,
      _ref$jobPositionId = _ref.jobPositionId,
      jobPositionId = _ref$jobPositionId === void 0 ? '' : _ref$jobPositionId,
      redirectUrl = _ref.redirectUrl,
      ambassadorRefCode = _ref.ambassadorRefCode,
      title = _ref.title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'secondary-outline' : _ref$variant,
      _onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      shortUrl = _React$useState2[0],
      setShortUrl = _React$useState2[1];

  var globalService = useGlobalsService();
  var url = useMemo(function () {
    if (redirectUrl) {
      if (ambassadorRefCode) return "".concat(redirectUrl).concat(ambassadorRefCode ? "".concat(redirectUrl.includes('?') ? "&" : "?").concat(commonString(ambassadorRefCode)) : "");
      return redirectUrl;
    }

    if (jobPositionId) {
      if (ambassadorRefCode) return "".concat(BASE_URL, "/posizione/").concat(jobPositionId, "?").concat(commonString(ambassadorRefCode));
      return "".concat(BASE_URL, "/posizione/").concat(jobPositionId, "?utm_source=referral");
    }

    return '';
  }, [ambassadorRefCode, jobPositionId, redirectUrl]);
  var getUrl = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$globalService$, _yield$globalService$2, _yield$globalService$3, _shortUrl;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (url) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", url);

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return globalService.createShortenUrl({
              original_url: url
            });

          case 5:
            _context.t1 = _yield$globalService$ = _context.sent;
            _context.t0 = _context.t1 === null;

            if (_context.t0) {
              _context.next = 9;
              break;
            }

            _context.t0 = _yield$globalService$ === void 0;

          case 9:
            if (!_context.t0) {
              _context.next = 13;
              break;
            }

            _context.t2 = void 0;
            _context.next = 14;
            break;

          case 13:
            _context.t2 = (_yield$globalService$2 = _yield$globalService$.data) === null || _yield$globalService$2 === void 0 ? void 0 : (_yield$globalService$3 = _yield$globalService$2.data) === null || _yield$globalService$3 === void 0 ? void 0 : _yield$globalService$3.short_url;

          case 14:
            _shortUrl = _context.t2;
            setShortUrl(_shortUrl);
            return _context.abrupt("return", _shortUrl);

          case 19:
            _context.prev = 19;
            _context.t3 = _context["catch"](2);
            console.error("Error while creating short url: ".concat(_context.t3));
            setShortUrl(url);
            return _context.abrupt("return", url);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 19]]);
  })), [globalService, url]);
  React.useEffect(function () {
    getUrl();
  }, [getUrl]);

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(RWebShare, {
    data: {
      title: "".concat(title !== null && title !== void 0 ? title : t('share_location_with_colleagues'), " ;)"),
      text: text,
      url: shortUrl
    },
    onClick: function onClick() {
      _onClick && _onClick();
    },
    children: /*#__PURE__*/_jsx(Button, _objectSpread({
      variant: variant,
      title: buttonTitle
    }, rest))
  });
};
export default JobShareModal;